import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import { GET_AGP_REPORT_DETAIL_API, GET_AGP_GUEST_REPORT_DETAIL_API, GET_CALLS_REPORT_DETAIL_API, GET_APO_REPORT_DETAIL_API, GET_TOTAL_SALES_REPORT_DETAIL_API } from "@apis/apiPath";

const useReportDetailApi = () => {
	const Ajax = useAjax();

	const getAGPReportDetailApi = useCallback(
		async (dateString, dataKeyName) => {
			return await Ajax.get(GET_AGP_REPORT_DETAIL_API(dateString, dataKeyName));
		},
		// eslint-disable-next-line
		[]
	);

	const getAGPGuestReportDetailApi = useCallback(
		async (dateString, dataKeyName) => {
			return await Ajax.get(GET_AGP_GUEST_REPORT_DETAIL_API(dateString, dataKeyName));
		},
		// eslint-disable-next-line
		[]
	);

	const getCallsReportDetailApi = useCallback(
		async (dateString, dataKeyName) => {
			return await Ajax.get(GET_CALLS_REPORT_DETAIL_API(dateString, dataKeyName));
		},
		// eslint-disable-next-line
		[]
	);

	const getAPOReportDetailApi = useCallback(
		async (dateString, dataKeyName) => {
			return await Ajax.get(GET_APO_REPORT_DETAIL_API(dateString, dataKeyName));
		},
		// eslint-disable-next-line
		[]
	);

	const getTotalSalesReportDetailApi = useCallback(
		async (dateString, dataKeyName) => {
			return await Ajax.get(GET_TOTAL_SALES_REPORT_DETAIL_API(dateString, dataKeyName));
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getAGPReportDetailApi,
		getAGPGuestReportDetailApi,
		getCallsReportDetailApi,
		getAPOReportDetailApi,
		getTotalSalesReportDetailApi,
	};
};

export default useReportDetailApi;
